import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import {
  ABBREVIATE_NUMBER,
  OUTPUT_IDENTIFIER,
  OUTPUT_LIMIT,
  OUTPUT_SEPERATOR,
  STATIC_DATA,
} from 'src/shared/data-store';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { cloneDeep } from 'lodash';
import * as Highcharts from 'highcharts';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { CONFIG } from 'src/helper/app-config';
import Swal from 'sweetalert2';
import {
  columnNameMappingForFullDataDownload,
  data,
  mapperForOutputDataKPIs,
} from 'src/helper/dataTable';
import { Papa } from 'ngx-papaparse';
import {
  PRICE_CHANGE_MAPPER,
  REGION_LEADER,
  STATIC_DISPLAY_KEYS,
  STATIC_KEYS,
} from 'src/app/shared/shared-config';
import { errorOrSuccessPopup } from 'src/helper/utilities';
export interface UserData {
  id: string;
  name: string;
  progress: string;
  fruit: string;
}

@Component({
  selector: 'app-output-summary',
  standalone: false,

  templateUrl: './output-summary.component.html',
  styleUrl: './output-summary.component.scss',
})
export class OutputSummaryComponent implements OnInit {
  Object = Object;
  volumeByMcPricingColumns = [];
  barPadding = 2;
  public highcharts = Highcharts;
  self = this;
  summaryCardsData = {};
  summaryChildData = {};
  summaryChildAbsChange = {};
  summaryChildPercentChange = {};
  summaryKeys = ['name', 'revenue', 'volume', 'margin', 'share'];
  summaryChildKey = [
    'net_revenue_scenario',
    'scenario_volume',
    'margin_scenario',
    'market_share',
  ];
  summaryChildAbsChangeKey = [
    'net_revenue_change',
    'margin_change',
    'volume_change',
    'market_share_percentage',
  ];
  summaryChildPercentChangeKey = [
    'net_revenue_change_percentage',
    'margin_scenario_percentage',
    'percentage_volume_change',
    'market_share_percentage',
  ];
  summaryCardBase = {};
  volumeChartConfig = {
    credits: {
      enabled: false,
    },
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      title: {
        enabled: false,
      },
      labels: {
        style: {
          color: '#25d4cf',
          fontSize: '12px',
          fontWeight: 700,
        },
      },
      gridLineWidth: 0,
    },
    yAxis: {
      labels: {
        enabled: false,
      },
      title: {
        enabled: false,
      },
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },

    tooltip: {
      formatter() {
        return '<b>' + this.x + '</b><br/>' + ABBREVIATE_NUMBER(this.y, 1);
      },
    },

    series: [
      {
        name: 'Volume',
        data: [],
        colorByPoint: true,
        colors: ['#783A00', '#A6A6A6', '#FFC000', '#4B3C32'],
      },
    ],
    update: false,

    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            // let isPercentage = this.point.selectedView === 'Percent' ? '%' : '';
            // return ABBREVIATE_NUMBER(this.y, 0) + isPercentage;
            return ABBREVIATE_NUMBER(this.y, 1);
          },
        },
      },
    },
  };
  revenueChartConfig = {
    credits: {
      enabled: false,
    },
    chart: {
      type: 'column',
    },
    update: false,
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      title: {
        enabled: false,
      },
      labels: {
        style: {
          color: '#25d4cf',
          fontSize: '12px',
          fontWeight: 700,
        },
      },
      gridLineWidth: 0,
    },
    yAxis: {
      labels: {
        enabled: false,
      },
      title: {
        enabled: false,
      },
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: 'Net Revenue',
        data: [],
        colorByPoint: true,
        colors: ['#783A00', '#A6A6A6', '#FFC000', '#4B3C32'],
      },
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return ABBREVIATE_NUMBER(this.y, 2) + ' %';
          },
        },
      },
    },
    tooltip: {
      formatter() {
        return (
          '<b>' + this.x + '</b><br/>' + ABBREVIATE_NUMBER(this.y, 2) + ' %'
        );
      },
    },
  };

  profitChartConfig: any = {
    credits: {
      enabled: false,
    },
    chart: {
      type: 'column',
    },
    update: false,
    title: {
      text: '',
    },
    xAxis: {
      categories: [],
      title: {
        enabled: false,
      },
      labels: {
        style: {
          color: '#25d4cf',
          fontSize: '12px',
          fontWeight: 700,
        },
      },
      gridLineWidth: 0,
    },
    yAxis: {
      labels: {
        enabled: false,
      },
      title: {
        enabled: false,
      },
      gridLineWidth: 0,
    },
    legend: {
      enabled: false,
    },
    series: [
      {
        name: 'VC Margin',
        data: [],
        colorByPoint: true,
        colors: ['#783A00', '#A6A6A6', '#FFC000', '#4B3C32'],
      },
    ],
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return ABBREVIATE_NUMBER(this.y, 1);
          },
        },
      },
    },
    tooltip: {
      formatter() {
        return '<b>' + this.x + '</b><br/>' + ABBREVIATE_NUMBER(this.y, 1);
      },
    },
  };

  volumeByPricingTableData = [];
  defaultData = {
    base_scenario: {},
    child_scenarios: [],
  };

  kpiOptions = data['KPI'];
  viewByOptions = data['viewBy'];
  selectedKPI: string = 'Volume';
  selectedViewBy: string = 'Retailer';
  retailer = STATIC_DISPLAY_KEYS.RETAILER;
  isAggregatedActive = true;
  showAll = false;

  @ViewChildren(MatMenuTrigger) trigger: MatMenuTrigger;
  selectedFilters: any = {};
  constructor(
    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
    private papa: Papa,
  ) {
    // Create 100 users
  }
  baseScenarioId;
  childScenarioId;
  key = false;
  chips = [
    {
      name: 'Absolute',
      value: 'Absolute',
      selected: true,
    },
    {
      name: 'Percent',
      value: 'Percent',
      selected: false,
    },
  ];
  baseScenarioName = '';

  globalMapper = {
    graph: {
      base: {
        grossProfit: 'margin_base',
        share: 'base_market_share',
        volume: 'base_volume',
      },
      child: {
        grossProfit: 'margin_scenario',
        percentageGrossProfit: 'margin_scenario_percentage',
        share: 'market_share',
        percentageShare: 'market_share',
        volume: 'scenario_volume',
        volumePercentage: 'percentage_volume_change',
      },
    },
    summary: {
      base: {
        net_revenue_base: 'Net Revenue',
        base_volume: 'Volume',
        margin_base: 'Gross Margin',
        base_market_share: 'Share',
      },
      child: {
        revenue: 'Net Revenue',
        volume: 'Volume',
        margin: 'Gross Margin',
        share: 'Share',
      },
    },
  };
  viewByMapper = {
    Retailer: 'retailer',
    'Brand Pack Variant': 'BrandPackVariant',
    Brand: 'BrandHouse',
    Manufacturer: 'Manufacturer',
    'Brand Variant': 'BrandVariant_x',
    'Sub Brand': 'BrandPackVariant',
  };
  hideFilters = false;
  dataLoader = false;
  selectedChannel = '';
  childScenarioName = '';
  index = 0;
  disableApply = true;
  baseDetails;
  childDetails;
  aggData = [];
  volumeText = 'Region';
  channel = '';
  chartRef: Highcharts.Chart;
  @ViewChild('volumeChart') componentRef;

  revenueChartRef: Highcharts.Chart;
  @ViewChild('revenueChart') revenueChartComponentRef;

  grossRevenueChartRef: Highcharts.Chart;
  @ViewChild('grossRevenueRef') grossRevenueChartComponentRef;
  defaultSubChannelValues = [];
  isReset = false;
  addLeftToRightDisableFunctionality = false;
  resetOtherFiltersBasedCurrentSelection = false;
  newGroupFilters = {};
  scenarioFilters = cloneDeep(STATIC_DATA.OUTPUT_SCENARIO_FILTERS);
  scenarioFilterOptions = {};
  scenarioDefaultFilterOption = {};
  scenarioSelectedFilters: any = {};
  apiCallIndex = 0;
  @ViewChild(MatPaginator)
  paginator: MatPaginator | any;
  regionLeader = REGION_LEADER;
  priceChangeMapper = PRICE_CHANGE_MAPPER;
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      console.log('============Params============', params);
      this.baseDetails = params?.['baseDetails'];
      if (this.baseDetails) {
        this.baseDetails = JSON.parse(this.baseDetails);
        this.baseScenarioName = this.baseDetails['base_scenario_name'];
        this.baseScenarioId = this.baseDetails['base_id'];
        this.channel = this.baseDetails.channel;
        if (this.baseDetails['price'] === PRICE_CHANGE_MAPPER.POST_CODE_PLAN) {
          this.outputFilters = this.outputFilters.map((obj) => {
            if (obj.name === STATIC_KEYS.RETAILER) {
              obj.displayName = REGION_LEADER;
            }
            return obj;
          });
        }
      }

      this.childDetails = params?.['childDetails'];
      if (this.childDetails) {
        this.childDetails = JSON.parse(this.childDetails);
        this.childScenarioId = this.childDetails['child_id'];
        this.childScenarioName = this.childDetails['name'];
      }
      this.scenarioDefaultFilterOption = {
        child_scenario: [this.childScenarioName],
      };
      this.scenarioSelectedFilters = {
        ...this.scenarioDefaultFilterOption,
      };
      let payload = {
        base_scenario_name: this.baseScenarioName,
        child_scenario_name: this.childScenarioName,
        // base_scenario_name: 'test',
        // child_scenario_name: 'string',
      };
      this.dataService
        .postRequest(payload, CONFIG.API2.GET_CHILD_SCENARIOS_OF_BASE)
        .then((res) => {
          let temp = res['all_child_scenarios'].map(
            (o) => o.child_scenario_name,
          );
          // this.scenarioFilterOptions = {...res["available_keys"]};
          // this.defaultFilterOption = { ...res["available_keys"] };
          this.scenarioFilterOptions = {
            child_scenario: temp,
          };
        });
      this.updateFilters();
    });
  }
  ngAfterViewInit() {
    this.dataSourceTable.paginator = this.paginator;
  }
  chartCallback: Highcharts.ChartCallbackFunction = (chart) => {
    this.chartRef = chart;
  };
  revenueChartCallback: Highcharts.ChartCallbackFunction = (chart) => {
    this.revenueChartRef = chart;
  };
  grossRevenueChartCallback: Highcharts.ChartCallbackFunction = (chart) => {
    this.grossRevenueChartRef = chart;
  };
  remove(fruit): void {
    const index = this.selectedFilters.indexOf(fruit);

    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
    }
  }
  resetFilters() {
    this.userChangedFilters = {};
    this.selectedFilters = {};
    this.updateFilters();
    this.applyFilterChange();
  }
  // user changed variable
  userChangedFilters = {};
  filterHandle(eventObj) {
    this.selectedFilters = eventObj['overAllSelections'];
    console.log('this.selectedFilters===>', this.selectedFilters);
    let filterNameToCheck = this.channel === 'MT' ? 'brand_revised' : 'ppg';
    // if (
    //   eventObj.name === filterNameToCheck &&
    //   eventObj.event === "DefaultApply"
    // ) {
    //   console.log(eventObj);

    //   // this.getLevelFiltersData();
    // }
    if (eventObj.event === 'apply' || eventObj.event === 'clear') {
      console.log(eventObj);
      this.userChangedFilters = {
        ...this.userChangedFilters,
        [eventObj['name']]: eventObj['selectedFilters'],
      };
      this.updateFilters();
    }
  }
  applyFilterChange() {
    this.getSummaryCardDetails();
    this.getChartsAndTableData();
    this.getTableData();
  }
  scenarioFilterHandle(eventObj) {
    this.scenarioSelectedFilters = eventObj['overAllSelections'];
    if (eventObj.event === 'apply' || eventObj.event === 'clear') {
      console.log(eventObj);
    }
  }
  defaultFilterOption = {};
  filterLoader = false;
  updateFilters() {
    let payload = {
      base_scenario_name: this.baseScenarioName,
      child_scenario_name: this.childScenarioName,
      filter_details: {
        available_keys: [
          'retailer',
          'LengthBand',
          'Manufacturer',
          'PackContents',
          'BrandPackVariant',
          'PriceSector',
          'TarLevel',
          'BrandVariant_x',
          'BrandHouse',
        ],
        // ...this.selectedFilters,
        ...this.userChangedFilters,
      },
      source: 'output-scenario',
    };
    // 1.Retailer   2.Manufacturer   3.Price Sector  4.LengthBand   5.PackContents 6. Tarlevel 7.brand 8.BrandPackVariant

    if (!this.apiCallIndex) {
      this.dataService.showLoader.next(true);
    }
    this.filterLoader = true;
    this.dataService
      .postRequest(payload, CONFIG.API2.OUTPUT_SUMMARY_DROPDOWN)
      .then((res) => {
        this.dataService.showLoader.next(false);
        let temp = {};
        if (res['disabled_keys']?.[0]) {
          // (temp = { ...res["available_keys"] }), { ...res["disabled_keys"][0] };
          temp = { ...res['disabled_keys'][0] };
        } else {
          temp = {};
        }
        this.newGroupFilters = this.mergeObjects(
          { ...res['available_keys'] },
          // { ...res["disabled_keys"][0] }
          temp,
        );
        // {...res['available_keys']};
        this.defaultFilterOption = { ...res['available_keys'] };
        this.selectedFilters = { ...this.defaultFilterOption };
      })
      .then((res) => {
        if (!this.apiCallIndex) {
          // this.getSummaryCardDetails();
          // this.getChartsAndTableData();
          // this.getTableData()
          this.applyFilterChange();
        }
        this.apiCallIndex++;
      })
      .finally(() => {
        this.filterLoader = false;
        this.dataService.showLoader.next(false);
      })
      .catch((error) => {
        this.dataService.showLoader.next(false);
        errorOrSuccessPopup('Error', 'Something Went Wrong!', 'error');
      });
  }

  outputFilters = cloneDeep(STATIC_DATA.OUTPUT_FILTERS);
  getCommonPayload() {
    // return {
    //   payload_dict: {},
    //   base_scenario_name: "two",
    //   all_child_scenario_name: ["child_one"],
    // };
    return {
      payload_dict: { ...this.selectedFilters },
      // payload_dict: { ...this.userChangedFilters },
      base_scenario_name: this.baseScenarioName,
      all_child_scenario_name: this.scenarioSelectedFilters.child_scenario,
    };
  }

  mergeObjects(obj1, obj2) {
    const result = {};

    // Function to merge arrays and keep only unique values
    const mergeArrays = (arr1, arr2) => [...new Set([...arr1, ...arr2])];

    // Iterate over keys in obj1
    for (const key in obj1) {
      if (obj1.hasOwnProperty(key)) {
        // Check if the key is present in obj2
        if (obj2.hasOwnProperty(key)) {
          // Merge arrays and store unique values in the result object
          result[key] = mergeArrays(obj1[key], obj2[key]);
        } else {
          // If the key is not present in obj2, copy the array from obj1

          result[key] = [...obj1[key]];
        }
      }
    }

    // Iterate over keys in obj2 that are not present in obj1
    for (const key in obj2) {
      if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
        // Copy the array from obj2 to the result object
        if (obj2[key]) {
          result[key] = [...obj2[key]];
        }
      }
    }

    return result;
  }

  childScenariosData = [];
  index2 = 0;
  initial = 0;
  intialCall = 0;
  layoutChange = false;
  downloadExcelFile = () => {
    this.dataService.showLoader.next(true);
    let payload = {
      base_scenario_name: this.baseScenarioName,
      child_scenario_name: this.scenarioSelectedFilters.child_scenario,
    };
    this.dataService
      .postRequest(payload, CONFIG.API2.FULL_OUTPUT_CSV)
      .then((res) => {
        let finalResponse = cloneDeep(res);
        let childNames = Object.keys(finalResponse);

        let responses = childNames.map((childName) => {
          let requiredStructure = [];

          // Determine the length of the arrays
          let length = Object.values(
            finalResponse[childName][STATIC_KEYS.RETAILER],
          ).length;

          // Iterate through each index and create objects in the required structure
          for (let i = 0; i < length; i++) {
            let obj = {};
            for (let key in finalResponse[childName]) {
              if (finalResponse[childName].hasOwnProperty(key)) {
                obj[key] = finalResponse[childName][key][i];
                if (
                  this.baseDetails['price'] ===
                    PRICE_CHANGE_MAPPER.POST_CODE_PLAN &&
                  key === STATIC_KEYS.RETAILER
                ) {
                  obj[REGION_LEADER] = finalResponse[childName][key][i];
                  delete obj[STATIC_KEYS.RETAILER];
                }
              }
            }
            requiredStructure.push(obj);
          }
          return {
            sheetName: childName,
            data: requiredStructure,
          };
        });

        const workbook = XLSX.utils.book_new();

        const columnMapping = columnNameMappingForFullDataDownload;

        const transformData = (dataList) => {
          return dataList.map((item) => {
            const transformedItem = {};
            for (const key in item) {
              if (columnMapping[key]) {
                transformedItem[columnMapping[key]] = item[key];
              } else {
                transformedItem[key] = item[key];
              }
            }
            return transformedItem;
          });
        };

        responses.forEach((response) => {
          // let definedCols = [
          //   'Category',
          //   'retailer',
          //   'Manufacturer',
          //   'BrandPackVariant',
          //   'BrandVariant',
          //   'BrandHouse',
          //   'TarLevel',
          //   'LengthBand',
          //   'PackContents',
          //   'PriceSector',
          //   'Period_FY24',
          //   'Base_Price',
          //   'Scenario Price',
          //   'Base Volume',
          //   'Scenario Volume',
          //   'Vol Change(abs)',
          //   'Vol Change(%)',
          //   'Base share',
          //   'Scenario share(%)',
          //   'Share Change',
          //   'Base Net Revenue',
          //   'Scenario Net Revenue',
          //   'Net Revenue Change(abs)',
          //   'Net Revenue Change(%)',
          //   'Base Gross Margin',
          //   'Scenario Gross Margin',
          //   'Gross Margin Change(abs)',
          //   'Gross Margin Change(%)',
          // ];

          const { sheetName, data } = response;
          // if (
          //   this.baseDetails['price'] === PRICE_CHANGE_MAPPER.POST_CODE_PLAN
          // ) {
          //   definedCols = definedCols.map((col) => {
          //     if (col === 'retailer') {
          //       return REGION_LEADER;
          //     }
          //     return col;
          //   });
          // }
          const worksheet = XLSX.utils.json_to_sheet(transformData(data));
          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        });

        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, `${this.baseScenarioName}.xlsx`);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.dataService.showLoader.next(false);
      });
  };

  absoluteDataExtractor() {
    const { base_scenario, child_scenarios } = this.defaultData;

    this.volumeChartConfig.series[0]['data'] = this.commonExtractorHighCharts(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['volume'],
      this.globalMapper.graph.base['volume'],
      true,
    );

    // this.volumeChartConfig = this.volumeChartConfig;
    this.volumeChartConfig.xAxis.categories = this.volumeChartConfig.series[0][
      'data'
    ].map((o) => o.name);
    this.volumeChartConfig.update = true;

    let revenueChartData = this.commonExtractor(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['share'],
      this.globalMapper.graph.base['share'],
      true,
    );
    this.revenueChartConfig.series[0]['data'] = revenueChartData.map(
      (o) => o.value,
    );
    this.revenueChartConfig.xAxis.categories = revenueChartData.map(
      (o) => o.name,
    );

    this.revenueChartConfig.update = true;

    let profitChartData = this.commonExtractor(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['grossProfit'],
      this.globalMapper.graph.base['grossProfit'],
      true,
    );

    this.profitChartConfig.series[0]['data'] = profitChartData.map(
      (o) => o.value,
    );
    this.profitChartConfig.xAxis.categories = profitChartData.map(
      (o) => o.name,
    );

    this.profitChartConfig.update = true;
  }

  percentDataExtractor() {
    const { base_scenario, child_scenarios } = this.defaultData;

    this.volumeChartConfig.series[0]['data'] = this.commonExtractorHighCharts(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['volume'],
      this.globalMapper.graph.base['volume'],
      false,
    );
    this.volumeChartConfig.xAxis.categories = this.volumeChartConfig.series[0][
      'data'
    ].map((o) => o.name);
    this.volumeChartConfig.update = true;

    let revenueChartData = this.commonExtractor(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['share'],
      this.globalMapper.graph.base['share'],
      false,
    );
    this.revenueChartConfig.series[0]['data'] = revenueChartData.map(
      (o) => o.value,
    );
    this.revenueChartConfig.xAxis.categories = revenueChartData.map(
      (o) => o.name,
    );

    this.revenueChartConfig.update = true;

    let profitChartData = this.commonExtractor(
      base_scenario,
      child_scenarios,
      this.globalMapper.graph.child['grossProfit'],
      this.globalMapper.graph.base['grossProfit'],
      false,
    );

    this.profitChartConfig.series[0]['data'] = profitChartData.map(
      (o) => o.value,
    );
    this.profitChartConfig.xAxis.categories = profitChartData.map(
      (o) => o.name,
    );

    this.profitChartConfig.update = true;
  }

  commonExtractor(base_scenario, child_scenario, key, baseKey, needBase?) {
    let baseValue = base_scenario?.[baseKey];
    let baseName = base_scenario.name;
    let childValues = child_scenario.map((o) => {
      let temp = {
        name: o?.child_name || o?.name,
        value: o[key],
      };
      return temp;
    });

    let chartData = [
      {
        name: baseName,
        value: baseValue,
      },
      ...childValues,
    ];
    return chartData;
  }

  commonExtractorHighCharts(
    base_scenario,
    child_scenario,
    key,
    baseKey,
    needBase?,
  ) {
    let baseValue = base_scenario?.[baseKey];
    let baseName = base_scenario.name;
    let childValues = child_scenario.map((o) => {
      return {
        name: o?.child_name || o?.name,
        y: o[key],
        selectedView: this.selectedView,
      };
    });

    let chartData = [
      {
        name: baseName,
        y: baseValue,
        selectedView: this.selectedView,
      },
      ...childValues,
    ];
    // if (!needBase) {
    //   chartData.shift();
    // }
    return chartData;
  }

  volumeTableLoader = false;
  tableChildData = [];
  tableBaseData;
  tableDataLoader = false;
  tableCsvOutput = [];
  getTableData() {
    this.tableDataLoader = true;
    let payload: any = this.getCommonPayload();
    payload = {
      ...payload,
      kpi: mapperForOutputDataKPIs[this.selectedKPI],
      view: this.viewByMapper[this.selectedViewBy],
    };
    this.dataService
      .postRequest(payload, CONFIG.API2.OUTPUT_TABLE_DATA)
      .then((res: any) => {
        console.log(res);
        res = {
          child_scenarios: res[0]['child_scenarios'],
          base_scenario: res[1]['base_scenario'],
        };
        let viewBy = [];
        let isShare =
          res.base_scenario.kpi === 'share' ||
          res.base_scenario.kpi === 'share_change';
        console.log(isShare);
        res.base_scenario.data.map((obj) => {
          Object.keys(obj).forEach((key) => {
            // obj[key] = this.formatNumber(obj[key],0);
            viewBy.push(key);
          });
        });
        // {
        //   name:'view 1',
        //   baseScenario:10,
        //   scenario1 :9
        //   scenario2:10
        //   }
        let finalStruc = [];
        res.base_scenario.data.forEach((entry) => {
          const viewName = Object.keys(entry)[0];
          const existingEntry = finalStruc.find(
            (item) => item[this.selectedViewBy] === viewName,
          );

          if (existingEntry) {
            existingEntry[res.base_scenario.name] = entry[viewName];
            existingEntry[
              `${OUTPUT_IDENTIFIER}${OUTPUT_SEPERATOR}${res.base_scenario.name}`
            ] = entry[viewName];
          } else {
            let val = isShare
              ? this.formatNumber(entry[viewName], 2) + ' %'
              : this.formatNumber(entry[viewName], 2);
            const newEntry = {
              [this.selectedViewBy]: viewName,
              [res.base_scenario.name]: val,
              [`${OUTPUT_IDENTIFIER}${OUTPUT_SEPERATOR}${res.base_scenario.name}`]:
                entry[viewName],
            };
            finalStruc.push(newEntry);
          }
        });
        res.child_scenarios.forEach((child, index) => {
          child.data.forEach((entry) => {
            const viewName = Object.keys(entry)[0];
            console.log(entry[viewName]);
            // entry = this.formatNumber(entry[viewName],0)
            const existingEntry = finalStruc.find(
              (item) => item[this.selectedViewBy] === viewName,
            );
            if (existingEntry) {
              existingEntry[child.name] = isShare
                ? this.formatNumber(entry[viewName], 2) + ' %'
                : this.formatNumber(entry[viewName], 2);
              existingEntry[
                `${OUTPUT_IDENTIFIER}${OUTPUT_SEPERATOR}${child.name}`
              ] = entry[viewName];
            } else {
              let val = isShare
                ? this.formatNumber(entry[viewName], 2) + ' %'
                : this.formatNumber(entry[viewName], 2);
              const newEntry = {
                [this.selectedViewBy]: viewName,
                [child.name]: val,
                [`${OUTPUT_IDENTIFIER}${OUTPUT_SEPERATOR}${child.name}`]:
                  entry[viewName],
              };
              finalStruc.push(newEntry);
            }
          });
        });

        this.dataSourceColumns = Object.keys(finalStruc[0]);
        this.dataSourceColumns = this.dataSourceColumns.filter(
          (column) => !column.includes(OUTPUT_IDENTIFIER + OUTPUT_SEPERATOR),
        );
        this.dataSourceTable.data = finalStruc;
        console.log(finalStruc);
        // this.tableChildData = res.data[0].child_scenarios;
        // this.tableBaseData = [res.data[1]["base_scenario"]];
        this.tableDataLoader = false;
      })
      .catch((error) => {
        this.tableDataLoader = false;
        Swal.fire('Error', `Some thing went wrong`, 'error').then(() => {
          return;
        });
        return;
      });
  }
  downloadCSV() {
    let columns = Object.keys(this.dataSourceTable.data[0]).filter(
      (column) =>
        column.includes(OUTPUT_IDENTIFIER + OUTPUT_SEPERATOR) ||
        column === this.selectedViewBy,
    );
    let tableData = cloneDeep(this.dataSourceTable.data);

    tableData = tableData.map((obj) => {
      let temp = {};

      columns.map((col) => {
        let columnName = col.split(OUTPUT_SEPERATOR)[1];
        if (!columnName) {
          const keyTobe =
            this.selectedViewBy === 'Brand Variant'
              ? 'Sub Brand'
              : this.selectedViewBy === 'Brand Pack Variant'
                ? 'SKU Description'
                : this.selectedViewBy;
          temp[keyTobe] = obj[col];
          if (
            this.baseDetails['price'] === PRICE_CHANGE_MAPPER.POST_CODE_PLAN &&
            col === STATIC_DISPLAY_KEYS.RETAILER
          ) {
            temp[REGION_LEADER] = obj[col];
            delete temp[keyTobe];
          }
        } else {
          temp[columnName] = obj[col];
        }
      });
      return temp;
    });

    this.downloadCSVFile(tableData);
  }
  downloadCSVFile(jsonData) {
    const csv = this.papa.unparse(jsonData);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'volume-by-pricing.csv');
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  getChartsAndTableData() {
    this.dataLoader = true;
    let payload = this.getCommonPayload();
    this.dataService
      .postRequest(payload, CONFIG.API2.OUTPUT_DATA_GRAPH)
      .then((res: any) => {
        if (res['status'] == 400) {
          Swal.fire('Error', `${res.data}`, 'error').then(() => {
            // this.router.navigate(["/library"]);
            return;
          });
          return;
        }
        let { data } = res;
        let finalData = {
          ...data[0],
          ...data[1],
        };
        this.defaultData = {
          base_scenario: {},
          child_scenarios: [],
        };
        console.log(this.defaultData);
        console.log('default in charts and table');
        finalData['base_scenarios'] = {
          ...finalData['base_scenarios'],
          ...this.defaultData['base_scenarios'],
        };
        finalData['child_scenarios'] = [
          ...finalData['child_scenarios'],
          ...this.defaultData['child_scenarios'],
        ];
        finalData['child_scenarios'] = finalData['child_scenarios'].filter(
          (obj, index, self) =>
            index === self.findIndex((t) => t.name === obj.name),
        );
        finalData['child_scenarios'] = finalData['child_scenarios'].map(
          (obj) => {
            let temp = this.defaultData['child_scenarios'].find(
              (o) => o.name === obj.name,
            );
            return {
              ...temp,
              ...obj,
            };
          },
        );
        this.defaultData = finalData;

        console.log(this.defaultData);
        console.log('after filling in table and chart');

        let index = this.chips.findIndex((o) => o.selected);
        this.viewBy(index);
        this.dataLoader = false;
      })
      .catch((err) => {
        console.log(err);
        Swal.fire('Error', `Some thing went wrong`, 'error').then(() => {
          // this.router.navigate(["/library"]);
          return;
        });
        return;
      });
  }
  summaryCardLoader = false;
  getSummaryCardDetails() {
    let payload = this.getCommonPayload();
    this.summaryCardLoader = true;
    this.dataService
      .postRequest(payload, CONFIG.API2.OUTPUT_SUMMARY_CARD)
      .then((res: any) => {
        this.summaryCardLoader = false;
        console.log('summary Card', res.data);
        this.summaryCardsData = this.extractSummaryData(res.data[0]);
        this.summaryCardBase = [res.data[1]['base_scenario']];
        console.log(
          'Keys without "percentage":',
          this.extractSummaryData(res.data[0]),
        );
      })
      .catch((err) => {
        console.log('ERROR SUMMARY CARD ', err);
        this.summaryCardLoader = false;
      });
  }
  getSortedKeys(scenario: any): string[] {
    return Object.keys(scenario)
      .filter((key) => key !== 'name')
      .sort()
      .reverse();
  }
  extractSummaryData(apiResponse) {
    let resultData = [];

    apiResponse.child_scenarios.forEach((scenario) => {
      let scenarioData = {};

      this.summaryKeys.forEach((key) => {
        if (key === 'name') {
          scenarioData[key] = scenario[key];
        } else {
          const baseKey = this.findMatchingKey(key, this.summaryChildKey);
          const absChangeKey = this.findMatchingKey(
            key,
            this.summaryChildAbsChangeKey,
          );
          const percentChangeKey = this.findMatchingKey(
            key,
            this.summaryChildPercentChangeKey,
          );

          scenarioData[this.getLabel(key)] = {
            baseData: scenario[baseKey],
            absChange: scenario[absChangeKey],
            percentChange: scenario[percentChangeKey],
          };
        }
      });

      resultData.push(scenarioData);
    });

    return resultData;
  }
  getLabel(key: string): string {
    const mappedLabel = this.globalMapper.summary.base[key.toLowerCase()];
    return mappedLabel || key;
  }
  findMatchingKey(mainKey, keyList) {
    return (
      keyList.find((changeKey) =>
        changeKey.toLowerCase().includes(mainKey.toLowerCase()),
      ) || null
    );
  }

  dataSourceTable = new MatTableDataSource();
  dataSourceColumns = [];

  sortObjectByValues(obj: Record<string, any>): Record<string, any> {
    // Convert object entries to array and sort based on values
    const sortedArray = Object.entries(obj)
      .sort((a, b) => a[1].localeCompare(b[1]))
      .reverse();

    // Convert sorted array back to object
    const sortedObject: Record<string, string> = {};
    for (const [key, value] of sortedArray) {
      sortedObject[key] = value;
    }

    return sortedObject;
  }
  formatNumber(num, fix) {
    return ABBREVIATE_NUMBER(num, fix);
  }
  exit() {
    this.router.navigate(['/library']);
  }
  selectedView = '';
  viewBy(i) {
    this.chips[i]['selected'] = !this.chips[i]['selected'];
    this.chips = this.chips.map((obj, ind) => {
      if (i !== ind) {
        obj.selected = false;
      }
      return obj;
    });

    let selected = this.chips.find((chip) => chip.selected);
    if (!selected) {
      this.chips[i].selected = true;
      selected = this.chips.find((chip) => chip.selected);
    }
    if (selected.value === 'Percent') {
      this.selectedView = 'Percent';
      this.percentDataExtractor();
      // this.volumeChartConfig.yAxis.title.text = 'Volume (%)';
      // this.revenueChartConfig.yAxis.title.text = 'Net Revenue (%)';
      this.profitChartConfig.yAxis.title.text = 'VC Margin (%)';
    }
    if (selected.value === 'Absolute') {
      this.selectedView = 'Absolute';
      this.absoluteDataExtractor();
      // this.volumeChartConfig.yAxis.title.text = 'Volume';
      // this.revenueChartConfig.yAxis.title.text = 'Net Revenue';
      this.profitChartConfig.yAxis.title.text = 'VC Margin';
    }
  }
  goBack() {
    this.router.navigate(['/scenario-creation'], { queryParams: { tab: '2' } });
  }
}

/** Builds and returns a new User. */

/**  Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license */
